import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface ContactUpdatedPayload extends TimestampPayload {
  placeUuid: string;
}
export const contactUpdated = createAction<ContactUpdatedPayload>('CONTACT_UPDATED');
